import React, { useState, useEffect, useRef } from 'react'

import { Box, Typography } from '@mui/material'
import './styles.css'
import GraphToolbar from '../default-toolbar'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { graph_theme, convert_time, defaultNames } from '../default-toolbar'

import LoadingButton from '@mui/lab/LoadingButton';

import { exportHtmlToImage } from "../../../../../utils/exportHtmlToImage";

import ExportIcon from '@mui/icons-material/Download';

import BarChart from "../../../../D3/BarChart";

const columns = graph => {
  const columns = []
  if (graph === 'agent')
    columns.push({ field: 'agent_name', headerName: 'Operador', flex: 1, renderCell: defaultNames })
  else columns.push({ field: 'queue_description', headerName: 'Fila', flex: 1, renderCell: defaultNames })
  columns.push({
    field: 'name',
    headerName: 'Tag',
    flex: 1,
  })
  columns.push({
    field: 'count',
    headerName: 'Quantidade',
    flex: .5
  })
  return columns
}

const Tags = ({ data, option, periodText }) => {

  const [parsedData, setParsedData] = useState([])

  const containerRef = useRef(null)

  const handleFilterModelChange = (filterModel) => {
    const filteredData = data.rows.filter((row) => {
      return filterModel.items.every(({ columnField, value }) => {
        const cellValue = row[columnField];
        return String(cellValue).toLowerCase().includes(String(value).toLowerCase());
      });
    });
    setParsedData(getAggregatedData({ rows: filteredData }))
  }

  const getAggregatedData = (data) => {
    if (data.rows && data.rows.length > 0) {
      const aggregatedData = data.rows.reduce((acc, { name, count }) => {
        if (!acc[name])
          acc[name] = { label: name, value: 0 };
        acc[name].value += count;
        return acc;
      }, {});

      return Object.values(aggregatedData);
    }
    return [];
  }

  useEffect(() => {
    setParsedData(getAggregatedData(data))
  }, [data])

  return (
    <Box className='graph-main-divisor'>
      <Box className='graph-main-table'>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={graph_theme}>
            <DataGridPro
              density='compact'
              columns={columns(option)}
              rows={data?.rows.map((r, index) => ({ ...r, id: index + 1 }))}
              hideFooter={true}
              components={{
                Toolbar: GraphToolbar
              }}
              onFilterModelChange={handleFilterModelChange}
            />
          </ThemeProvider>
        </StyledEngineProvider>
      </Box>
      <Box className='graph-main-dashboards'>
        <Box className='graph-time-rows'>
          {data.rows?.length !== 0 &&
            <>
              <Box sx={{ position: 'absolute', right: '0' }}>
                <LoadingButton startIcon={<ExportIcon />}
                  sx={{ position: 'absolute', right: '2rem', top: '0rem', zIndex: 1 }}
                  onClick={() => exportHtmlToImage(containerRef.current)}
                >
                  Exportar
                </LoadingButton>
              </Box>
              <Box className='new-graphs-wrapper'>
                <div ref={containerRef} style={{ width: "100%", height: "100%", padding: "1rem", position: 'relative' }}>
                <img style={{ width: '10rem', display: 'none', position: 'absolute', right: 0 }} src="/static/media/kwik_color.f6459d28.png" alt="logo" class="logo" id="logo" className='showcopyright'></img>
                  <Typography variant="subtitle1">Total de <em>"tags"</em> de atendimentos, {periodText}</Typography>
                  <BarChart data={parsedData} />
                  <Typography sx={{ display: 'none', position: 'absolute', bottom: 0 }} variant="body2" align="center" className='showcopyright'>
                    Copyright (c) {new Date().getFullYear()} - Instant Solutions Tecnologia e Informática Ltda.
                  </Typography>
                </div>
              </Box>
            </>
          }
        </Box>
      </Box>
    </Box>
  )
}

export default Tags
